import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail, MapPin, Clock, Send, ChevronDown } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    postcode: '',
    appliance: '',
    faultNotes: ''
  });
  const [openServiceIndex, setOpenServiceIndex] = useState<number | null>(0);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your enquiry. We will be in touch within 24 hours.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const services = [{
    title: 'Engineer Callout & Diagnostics',
    description: 'Our qualified engineer will visit your property to assess your appliance, identify the fault, and provide a clear explanation of what needs to be done.'
  }, {
    title: 'Repair Visit (Labour Only)',
    description: 'Following diagnostics, our engineer will carry out the necessary repairs to restore your appliance to working order. Parts quoted separately.'
  }, {
    title: 'Service & Maintenance Visit',
    description: 'Regular maintenance helps prevent breakdowns and extends appliance life. Includes cleaning, testing, and minor adjustments.'
  }];
  const faqs = [{
    question: 'How quickly can you attend?',
    answer: 'We typically arrange engineer visits within 24-48 hours of your booking request, subject to availability in your area.'
  }, {
    question: 'What is your refund process?',
    answer: 'Full refunds are available within 14 days if no work has been carried out. Between 15-28 days, partial refunds may be granted at our discretion.'
  }];
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-464">
      <Header data-id="element-465" />
      <main className="flex-grow" data-id="element-466">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-467">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-468">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-469">
              Contact Caringhand
            </h1>
            <p className="text-xl text-gray-100" data-id="element-470">
              Your local appliance repair team — friendly, efficient and
              reliable
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-471">
          <div className="max-w-7xl mx-auto px-4" data-id="element-472">
            <div className="grid lg:grid-cols-2 gap-12" data-id="element-473">
              <div data-id="element-474">
                <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-475">
                  Get in Touch
                </h2>
                <p className="text-gray-700 mb-8 leading-relaxed" data-id="element-476">
                  We are here to help with all your appliance repair needs. Fill
                  in the form below or contact us directly using the details
                  provided.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4" data-id="element-477">
                  <div data-id="element-478">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-479">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-480" />
                  </div>
                  <div data-id="element-481">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-482">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-483" />
                  </div>
                  <div data-id="element-484">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-485">
                      Phone Number *
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-486" />
                  </div>
                  <div data-id="element-487">
                    <label htmlFor="postcode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-488">
                      Postcode *
                    </label>
                    <input type="text" id="postcode" name="postcode" value={formData.postcode} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-489" />
                  </div>
                  <div data-id="element-490">
                    <label htmlFor="appliance" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-491">
                      Appliance Type *
                    </label>
                    <select id="appliance" name="appliance" value={formData.appliance} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none" data-id="element-492">
                      <option value="" data-id="element-493">Select an appliance</option>
                      <option value="washing-machine" data-id="element-494">Washing Machine</option>
                      <option value="dishwasher" data-id="element-495">Dishwasher</option>
                      <option value="tumble-dryer" data-id="element-496">Tumble Dryer</option>
                      <option value="cooker" data-id="element-497">Cooker/Oven</option>
                      <option value="fridge-freezer" data-id="element-498">Fridge/Freezer</option>
                      <option value="tv" data-id="element-499">Television</option>
                    </select>
                  </div>
                  <div data-id="element-500">
                    <label htmlFor="faultNotes" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-501">
                      Fault Notes *
                    </label>
                    <textarea id="faultNotes" name="faultNotes" value={formData.faultNotes} onChange={handleChange} rows={4} required placeholder="Please describe the issue with your appliance" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D7377] focus:border-transparent outline-none resize-none" data-id="element-502"></textarea>
                  </div>
                  <button type="submit" className="w-full bg-[#E8956B] text-white px-6 py-4 rounded-lg font-semibold hover:bg-[#D67D54] transition-colors shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-503">
                    <Send size={20} data-id="element-504" />
                    Send Enquiry
                  </button>
                </form>
              </div>
              <div data-id="element-505">
                <div className="bg-gray-50 p-8 rounded-xl shadow-sm mb-8" data-id="element-506">
                  <h3 className="text-2xl font-semibold mb-6 text-gray-900" data-id="element-507">
                    Contact Information
                  </h3>
                  <div className="space-y-6" data-id="element-508">
                    <div className="flex items-start gap-4" data-id="element-509">
                      <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-510">
                        <MapPin className="text-[#0D7377]" size={24} data-id="element-511" />
                      </div>
                      <div data-id="element-512">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-513">
                          Address
                        </h4>
                        <p className="text-gray-600" data-id="element-514">
                          157 Ashley Rd
                          <br data-id="element-515" />
                          Hale, Altrincham
                          <br data-id="element-516" />
                          WA15 9SD
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-517">
                      <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-518">
                        <Phone className="text-[#0D7377]" size={24} data-id="element-519" />
                      </div>
                      <div data-id="element-520">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-521">
                          Phone
                        </h4>
                        <a href="tel:08000554969" className="text-[#0D7377] hover:text-[#14919B] font-medium" data-id="element-522">
                          0800 055 4969
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-523">
                      <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-524">
                        <Mail className="text-[#0D7377]" size={24} data-id="element-525" />
                      </div>
                      <div data-id="element-526">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-527">
                          Email
                        </h4>
                        <a href="mailto:info@caringhand.it.com" className="text-[#0D7377] hover:text-[#14919B] font-medium" data-id="element-528">
                          info@caringhand.it.com
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-529">
                      <div className="w-12 h-12 bg-[#0D7377] bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-530">
                        <Clock className="text-[#0D7377]" size={24} data-id="element-531" />
                      </div>
                      <div data-id="element-532">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-533">
                          Opening Hours
                        </h4>
                        <div className="space-y-1 text-sm text-gray-600" data-id="element-534">
                          <p data-id="element-535">Monday - Friday: 9:00 AM - 5:00 PM</p>
                          <p data-id="element-536">Saturday - Sunday: Closed</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-8 rounded-xl shadow-sm mb-8" data-id="element-537">
                  <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-538">
                    Our Services
                  </h3>
                  <div className="space-y-3" data-id="element-539">
                    {services.map((service, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-540">
                        <button onClick={() => setOpenServiceIndex(openServiceIndex === index ? null : index)} className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-gray-100 transition-colors" data-id="element-541">
                          <h4 className="font-semibold text-sm text-gray-900" data-id="element-542">
                            {service.title}
                          </h4>
                          <ChevronDown className={`text-[#0D7377] transition-transform ${openServiceIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-543" />
                        </button>
                        {openServiceIndex === index && <div className="px-4 pb-3" data-id="element-544">
                            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-545">
                              {service.description}
                            </p>
                          </div>}
                      </div>)}
                  </div>
                </div>
                <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-546">
                  <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-547">
                    Quick FAQs
                  </h3>
                  <div className="space-y-3" data-id="element-548">
                    {faqs.map((faq, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-549">
                        <button onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)} className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-gray-100 transition-colors" data-id="element-550">
                          <h4 className="font-semibold text-sm text-gray-900" data-id="element-551">
                            {faq.question}
                          </h4>
                          <ChevronDown className={`text-[#0D7377] transition-transform ${openFaqIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-552" />
                        </button>
                        {openFaqIndex === index && <div className="px-4 pb-3" data-id="element-553">
                            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-554">
                              {faq.answer}
                            </p>
                          </div>}
                      </div>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-555" />
    </div>;
}